import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import { SiteSchema } from "@/components/feature/SeoSchema";
import Hero from "./components/Hero";
import CategoryDropdown from "./components/CategoryDropdown";
import CategoryGrid from "./components/CategoryGrid";
import AboutSection from "./components/AboutSection";
import GuideSection from "./components/GuideSection";

export default function Home() {
  return (
    <>
      <SiteSchema />
      <Navbar />
      <main>
        <Hero />
        <CategoryDropdown />
        <CategoryGrid />
        <AboutSection />
        <GuideSection />
      </main>
      <Footer />
    </>
  );
}